<template>
  <div class="timeline">
    <md-button
      v-for="(step, index) in steps"
      :key="index"
      class="step"
      :class="{complete: isComplete(index), 'current': isCurrent(index), active: isActive(index) }"
      :style="{backgroundColor: step.color}"
      @click="onStepClick(index)"
    >
      <div class="completion-bar" />
      <div class="dot" :style="{borderColor: stepColor(step, index)}" />
      <div class="completion-bar" />
    </md-button>
  </div>
</template>

<script>
export default {
  name: 'timeline',
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
    completedStepsCount: {
      type: Number,
      default: 0,
    },
    activeStep: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    isComplete(index) {
      return this.completedStepsCount > index;
    },
    isCurrent(index) {
      return this.completedStepsCount === index;
    },
    isActive(index) {
      return this.activeStep === index;
    },
    stepColor(step, index) {
      if (step.hasError) {
        return '#f92c2d';
      }
      if (step.hasWarning) {
        return '#faa11c';
      }
      if (this.isCurrent(index)) {
        return '#a2bed8';
      }
      if (!this.isComplete(index)) {
        return '#a9b3bc';
      }
      return '#a2bed8';
    },
    onStepClick(index) {
      this.$emit('step', index);
    },
  },
};
</script>

<style scoped>
.timeline {
  float: right;
  width: 30px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
}

.step {
  /* reset md-button styles */
  margin: 0;
  min-width: 0;
  border-radius: 0;

  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;

  box-shadow: 2px 3px 5px 0px rgba(0, 0, 0, 0.75);
  max-height: 60px;
  z-index: 1;
  position: relative;
}

.step.active {
  z-index: 0;
}

.dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: solid 5px;
  background-color: #fff;
  box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.75);
  position: relative;
  z-index: 2;
}

.completion-bar {
  flex: 1;
  width: 3px;
  background-color: #697a8a;
  box-shadow: 1px 0px 3px 0px rgba(0, 0, 0, 0.55);
  position: relative;
  z-index: 1;
}

.completion-bar {
  opacity: 0;
}

.step.complete .completion-bar {
  opacity: 1;
}

.step.current .completion-bar:first-child {
  opacity: 1;
}

.step:first-child .completion-bar:first-child,
.step:last-child .completion-bar:last-child {
  opacity: 0;
}
</style>

<style>
.timeline .md-button.step .md-button-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.timeline .md-button.step .md-ripple {
  flex: 1;
  padding: 0;
}
</style>